var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotLoginImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.914,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12003",
    d: "M9.752 9.367a4.4 4.4 0 1 0-6.511 0A6.491 6.491 0 0 0 0 14.991V15h.813v-.009a5.663 5.663 0 0 1 1.666-4.018 5.722 5.722 0 0 1 1.4-1.03 4.406 4.406 0 0 0 5.234 0 5.566 5.566 0 0 1 1.4 1.03 5.663 5.663 0 0 1 1.666 4.018V15H13v-.009a6.5 6.5 0 0 0-3.246-5.624m-3.253.627a3.583 3.583 0 1 1 1.4-.283 3.572 3.572 0 0 1-1.4.283",
    fill: "#869dad"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12004",
    d: "m16.625 3.476-2.341 2.889h2.338v.71h-3.66v-.484l2.384-2.878h-2.207v-.71h3.488v.472Z",
    fill: "#f24040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12005",
    d: "m21.914.558-2.776 3.426h2.774v.841h-4.341v-.574l2.824-3.41h-2.614V0h4.133v.558Z",
    fill: "#f24040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotLoginImg);
export default __webpack_public_path__ + "static/media/Not_Login_Img.699f9f0351356e008e7c876e70671836.svg";
export { ForwardRef as ReactComponent };